import { useQuery } from '@tanstack/react-query';
import { API } from '../../utils/amplifyWrapper';

const fetchRecentContent = async (org_id, integration_id) => {
    const res = await API.get('main', `/organisation/${org_id}/integration/${integration_id}/content?contentType=voice_over`);
    return (res.data || []).slice(0, 5);
};

export const useRecentContent = ({ org_id, integration_id }) => {
    return useQuery(
        ['recent-content', org_id, integration_id],
        () => fetchRecentContent(org_id, integration_id),
        {
            enabled: !!(org_id && integration_id),
            staleTime: 2 * 60 * 1000,
        }
    );
};
